<router-outlet>
	<um-http-loader></um-http-loader>
</router-outlet>